import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistlePenaltyShootoutStart extends DomainEvent<MatchEvent> {}
